import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  ancillaryImg,
  ancillaryTitles,
} from '@app/pages/ancillary-bundle-page/ancillary-bundle.constants';
import { AncillaryBundleItemType } from '@app/pages/ancillary-bundle-page/ancillary-bundle.enum';
import { AncillaryBundleItem } from '@app/pages/ancillary-bundle-page/ancillary-bundle.interfaces';

@Component({
  selector: 'ancillary-bundle-item',
  templateUrl: './ancillary-bundle-item.component.html',
  styleUrls: ['./ancillary-bundle-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AncillaryBundleItemComponent {
  title = '';
  img = '';
  ancillary: AncillaryBundleItem;
  isBundle = false;
  prefix = '';
  isChange = false;

  @Input() isSelected = false;
  @Input() discountSize = 0;

  @Input() set data(value: AncillaryBundleItem) {
    const type = value.type;

    this.ancillary = value;
    this.title = ancillaryTitles[type];
    this.img = ancillaryImg[type];
    this.isBundle = type === AncillaryBundleItemType.Bundle;
    this.prefix = value.prefix || '';
    this.isChange = value.isChange || false;
  }
}
